import useSWRMutation from "swr/mutation";
import { API_REST_METHODS } from "../../../common/constants";
import { fetcher } from "../../../common/hooks";

export const useDeactivateBulkDevices = ({
    companyId,
    locationId,
    onSuccess,
    onError,
}: {
    companyId: string;
    locationId: string;
    onSuccess?: () => void;
    onError?: (err: any, key: string) => void;
}) => {
    const {
        trigger: triggerDeactivateBulkDevices,
        isMutating: isLoadingDeactivateBulkDevices,
    } = useSWRMutation(
        `/api/device-management/v1/companies/${companyId}/locations/${locationId}/devices/deactivate-bulk`,
        (
            url: string,
            {
                arg,
            }: {
                arg: { deviceIds: string[] };
            }
        ) =>
            fetcher(url, {
                options: {
                    method: API_REST_METHODS.POST,
                    body: JSON.stringify(arg.deviceIds),
                },
            }),
        {
            onSuccess,
            onError,
        }
    );

    return {
        triggerDeactivateBulkDevices,
        isLoadingDeactivateBulkDevices,
    };
};
